import http from './httpService';

let apiEndpoint = '/artAroundTowns';

export function getArtAroundTownData() {
  return http.get(`${apiEndpoint}`);
}